module.exports = __webpack_public_path__ + "static/media/b-sci-major-22_LR.13d2493f.jpg";